var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { toDateTime } from 'helpers/Format';
import Report from '../components/Report';
import history from '../../../helpers/History';
var TicketCashDesks = /** @class */ (function (_super) {
    __extends(TicketCashDesks, _super);
    function TicketCashDesks() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleOnSelectItem = function (item) {
            // console.log('item: ', item)
            history.push("/ticketCashDesk/".concat(item.id), item);
        };
        _this.getNotUpload = function (items) {
            var ticketCashDeskNoUploaded = items.reduce(function (previousValue, currentValue) {
                var tickets = currentValue.printedStretchTickets;
                var ticketsNotUploaded = tickets.reduce(function (previousValue1, currentValue1) {
                    if (!currentValue1.id) {
                        previousValue1.push(currentValue1);
                    }
                    return previousValue1;
                }, []);
                if (ticketsNotUploaded.length > 0) {
                    currentValue.ticketsNotUploaded = ticketsNotUploaded;
                    previousValue.push(currentValue);
                }
                return previousValue;
            }, []);
            return ticketCashDeskNoUploaded;
        };
        return _this;
    }
    TicketCashDesks.prototype.componentDidMount = function () {
        this.props.store.reports.readTicketCashDesks();
    };
    TicketCashDesks.prototype.render = function () {
        var reports = this.props.store.reports;
        var headers = ['dateOpen', 'dateClose', 'username', 'terminal', 'modelo', 'tickets', 'checkins', 'totalDescuento', 'totalRefund', 'totalCash', 'totalCard', 'totalCredit', 'totalTranfer', 'totalOther', 'total'];
        var items = reports.ticketCashDesk;
        // console.log( 'TicketCashDesks - items: ', items.length)
        var ticketCashDeskNoUploaded = this.getNotUpload(items);
        console.log('ticketCashDeskNoUploaded: ', ticketCashDeskNoUploaded);
        return (React.createElement(Report, { onSelectItem: this.handleOnSelectItem, filterDate: false, header: headers, items: items, loading: !reports.ticketCashDesksLoaded, keyExtractor: function (ticketCashDesk) { return String(ticketCashDesk.id); }, format: function (ticketCashDesks) {
                return ticketCashDesks.map(function (ticketCashDesk) { return (__assign(__assign({}, ticketCashDesk), { dateOpen: toDateTime(ticketCashDesk.dateOpen), dateClose: toDateTime(ticketCashDesk.dateClose), checkins: ticketCashDesk.checkins, 
                    /*tickets: numeroTickets(ticketCashDesk, 'printed'),*/
                    username: ticketCashDesk.username, terminal: ticketCashDesk.terminalSN, modelo: ticketCashDesk.terminalBrand, total: ticketCashDesk.total + ticketCashDesk.totalDescuento })); });
            } }));
    };
    TicketCashDesks = __decorate([
        inject('store'),
        observer
    ], TicketCashDesks);
    return TicketCashDesks;
}(Component));
export var numeroTickets = function (item, type) {
    console.log('numeroTickets - item: ', item);
    var typeSale;
    switch (type) {
        case 'printed':
            typeSale = 'printedTickets';
            break;
        case 'refunded':
            typeSale = 'refundTickets';
            break;
        case 'bookinged':
            typeSale = 'bookingTickets';
            break;
        default: typeSale = 'printedTickets';
    }
    console.log('typeTicket', typeSale);
    console.log('item[typeSale]', item[typeSale]);
    var temp = item[typeSale];
    console.log('temp: ', temp);
    var tickets = temp[type];
    console.log('TicketCashDesk - numeroTickets - tickets: ', tickets);
    return tickets.length;
};
export default TicketCashDesks;



//////////////////
// WEBPACK FOOTER
// ./src/modules/Reports/containers/TicketCashDesks.tsx
// module id = 1152
// module chunks = 0